import CryptoJS from 'crypto-js';
function reliableAlphabeticalSort(a: string, b: string): number {
  return a.localeCompare(b, undefined, { 
    numeric: false, 
    sensitivity: 'base' 
  });
}
export function generateSHA512Hash(data: any): string {
    const normalizedData = JSON.stringify(data, Object.keys(data).sort(reliableAlphabeticalSort));
    return CryptoJS.SHA512(normalizedData).toString();
  }
  export function formatDateFromISOString(isoString: string): string {
    if(!isoString){
        return ''
    }
    const date = new Date(isoString);
    
    // Extract day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-based
    const year = date.getFullYear().toString();

    
    // Optional: Shift by 1 day if required
    // date.setDate(date.getDate() + 1);

    const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };

    return date.toLocaleDateString('en-US', options);
    // Return formatted string as "DD.MM.YYYY"
    // return `${year}-${month}-${day}`;
}

export function cmToFeetAndInches(cm:any) {
    const totalInches = cm / 2.54;
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);
    return { feet, inches };
  }
  export function feetAndInchesToCm(feet: number, inches: number): number {
    return Math.round((feet * 12 + inches) * 2.54);
  }

  // Convert kilograms to pounds
export function kgToLbs(kg: any): number {
    return parseFloat((kg * 2.20462).toFixed(2));
  }
  
  // Convert pounds to kilograms
  export function lbsToKg(lbs: any): number {
    return parseFloat((lbs / 2.20462).toFixed(2));
  }
  